<script setup>
import { twMerge } from "tailwind-merge";

const props = defineProps({
    class: String,
});
</script>

<template>
    <td :class="twMerge('py-4 pl-0 pr-8', props.class)">
        <slot></slot>
    </td>
</template>
